import { useEffect, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';

import Message from './components/Message/Message';

import defaultBackground from './assets/images/bg.png';

function App() {
  const { currentState, isVisible, currentMessage, setDelay } = useBroadcast();
  const { bg, bgColor, duration, oneLineDuration, pauseBetweenMessages } =
    useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg, bgColor]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && currentMessage && (
          <motion.div
            key={`msg-${currentState}`}
            style={{ width: '100%' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <Message
              message={currentMessage?.message || {}}
              setDelay={setDelay}
              currentState={currentState}
              duration={duration}
              oneLineDuration={oneLineDuration}
              pauseBetweenMessages={pauseBetweenMessages}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
